import { render } from "./BaseNavLink.vue?vue&type=template&id=30282b53&scoped=true&ts=true"
import script from "./BaseNavLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseNavLink.vue?vue&type=script&setup=true&lang=ts"

import "./BaseNavLink.vue?vue&type=style&index=0&id=30282b53&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30282b53"],['__file',"resources/js/vue/components/ui/BaseNavLink.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30282b53"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30282b53', __exports__)) {
    api.reload('30282b53', __exports__)
  }
  
  module.hot.accept("./BaseNavLink.vue?vue&type=template&id=30282b53&scoped=true&ts=true", () => {
    api.rerender('30282b53', render)
  })

}


export default __exports__